import { AuthService } from './../../../services/auth.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { GlobalService } from 'src/app/services/global.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Ticket, TrelloCard } from 'sharedTypes/client';
import { ChooseUserComponent } from 'src/app/shared/choose-user/choose-user.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OptionsdialogComponent } from 'src/app/shared/optionsdialog/optionsdialog.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-ticket-short',
    templateUrl: './ticket-short.component.html',
    styleUrls: ['./ticket-short.component.scss'],
    standalone: false,
})
export class TicketShortComponent implements OnInit, OnDestroy {
    @Input() ticket: Ticket = new Ticket();
    trelloCard: TrelloCard = new TrelloCard();
    cardSub: Subscription = new Subscription();

    constructor(
        public authService: AuthService,
        public firebaseService: FirebaseService,
        public glo: GlobalService,
        private dialog: MatDialog,
    ) {}
    ngOnDestroy(): void {
        if (this.cardSub) {
            this.cardSub.unsubscribe();
        }
    }
    ngOnInit(): void {
        if (this.ticket && this.ticket.trelloCardId) {
            this.subCard();
        }
    }

    subCard() {
        if (this.cardSub) {
            this.cardSub.unsubscribe();
        }
        if (!this.ticket?.ticketId) {
            return;
        }
        this.cardSub = this.firebaseService.getTicketCard(this.ticket.ticketId).subscribe((cards) => {
            if (cards && cards[0]) {
                this.trelloCard = cards[0];
            }
        });
    }

    getBackgroundColor() {
        let color = 'yellow';
        if (this.ticket.done) {
            return 'green';
        }
        if (this.ticket.prio > 0) {
            color = 'orange';
        }
        if (this.ticket.prio > 1) {
            color = 'red';
        }
        return color;
    }

    async closeTicket() {
        const res = await this.glo.confirm('Ticket schließen?').toPromise();
        if (res) {
            const savedTicket = JSON.parse(JSON.stringify(this.ticket));
            this.ticket.done = true;
            this.ticket.doneAt = new Date().toISOString();
            this.ticket.doneAtUnix = Date.now();
            this.ticket.doneBy = this.authService.getUid();

            this.firebaseService.saveTicket(this.ticket, savedTicket);
        }
    }
    async toggleBookmarkTicket() {
        this.ticket.bookmarked = !!this.ticket.bookmarked;
        const savedTicket = JSON.parse(JSON.stringify(this.ticket));
        this.ticket.bookmarked = !this.ticket.bookmarked;
        this.firebaseService.saveTicket(this.ticket, savedTicket);
    }

    async assignTicket() {
        const cfg = new MatDialogConfig();
        cfg.width = '600px';
        // cfg.data = {disableAbbrechen: true};
        cfg.data = {};

        cfg.disableClose = true;
        const dialogRef = this.dialog.open(ChooseUserComponent, cfg);

        const res = await dialogRef.afterClosed().toPromise();
        if (res) {
            const savedTicket = JSON.parse(JSON.stringify(this.ticket));
            this.ticket.assignedTo = res.uid;
            this.ticket.assignedAt = new Date().toISOString();
            this.ticket.assignedAtUnix = Date.now();
            this.ticket.assignedBy = this.authService.getUid();
            this.firebaseService.saveTicket(this.ticket, savedTicket);
        }
    }

    async toggleColor() {
        const cfg = new MatDialogConfig();

        cfg.width = '300px';

        const optionen = ['Keine Farbe', 'Grün', 'Orange', 'Blau', 'Rot'];
        const res = ['', 'green', 'orange', 'blue', 'red'];
        cfg.data = {
            titel: 'Bitte Farbe wählen',
            frage: '',
            optionen: optionen,
        };

        const dialogRef = this.dialog.open(OptionsdialogComponent, cfg);
        dialogRef.afterClosed().subscribe((result) => {
            if (result !== null && result !== undefined) {
                const savedTicket = JSON.parse(JSON.stringify(this.ticket));
                this.ticket.color = res[result] as any;
                this.firebaseService.saveTicket(this.ticket, savedTicket);
            }
        });
    }

    async setLevel() {
        const cfg = new MatDialogConfig();

        cfg.width = '300px';

        const optionen = ['Level 1', 'Level 2'];
        const res = [1, 2];
        cfg.data = {
            titel: 'Bitte Level wählen',
            frage: '',
            optionen: optionen,
        };

        const dialogRef = this.dialog.open(OptionsdialogComponent, cfg);
        dialogRef.afterClosed().subscribe((result) => {
            if (result !== null && result !== undefined) {
                const savedTicket = JSON.parse(JSON.stringify(this.ticket));
                this.ticket.level = res[result] as any;
                this.firebaseService.saveTicket(this.ticket, savedTicket);
            }
        });
    }

    async assignKategorie() {
        const cfg = new MatDialogConfig();

        cfg.width = '300px';

        const optionen = ['Keine Kategorie', 'Bug', 'Feature Request', 'Sonstige'];
        const res = ['', 'bug', 'feature', 'sonstiges'];
        cfg.data = {
            titel: 'Bitte Kategorie wählen',
            frage: '',
            optionen: optionen,
        };

        const dialogRef = this.dialog.open(OptionsdialogComponent, cfg);
        dialogRef.afterClosed().subscribe((result) => {
            if (result !== null && result !== undefined) {
                const savedTicket = JSON.parse(JSON.stringify(this.ticket));
                this.ticket.kategorie = res[result] as any;
                this.firebaseService.saveTicket(this.ticket, savedTicket);
            }
        });
    }

    getMediumIcon(): string {
        switch (this.ticket.medium) {
            case 'mail':
                return 'email';
            case 'call':
                return 'phone';
            case 'portal':
                return 'language';
            default:
                return 'help_outline';
        }
    }

    getMediumTooltip(): string {
        switch (this.ticket.medium) {
            case 'mail':
                return 'E-Mail';
            case 'call':
                return 'Anruf';
            case 'portal':
                return 'Portal';
            default:
                return 'Unbekannt';
        }
    }

    isUrgentUnassigned(): boolean {
        if (this.ticket.assignedTo || this.ticket.done) {
            return false;
        }

        const now = Date.now();
        const createdAt = this.ticket.createdAtUnix || new Date(this.ticket.createdAt).getTime();
        const hoursSinceCreated = (now - createdAt) / (1000 * 60 * 60);

        return hoursSinceCreated > 24;
    }

    getLastReplyIcon(): string {
        switch (this.ticket.lastAnswerBy) {
            case 'client':
                return 'reply';
            case 'support':
                return 'support_agent';
            default:
                return '';
        }
    }

    getLastReplyTooltip(): string {
        switch (this.ticket.lastAnswerBy) {
            case 'client':
                return 'Letzte Antwort vom Kunden';
            case 'support':
                return 'Letzte Antwort vom Support';
            default:
                return '';
        }
    }
}
